<template>
    <dashboard>
        <heading>
            <h1 slot="title">Students</h1>
            <template slot="buttons">
                <app-segment-control
                    v-if="!isMobileScreenSize()"
                    :value="state"
                    :options="[{ title: 'Active', value: 'active' }, { title: 'All', value: 'all' }]"
                    @input="stateChange"/>
                <app-button @click="addNewStudent">Add Student</app-button>
            </template>
        </heading>
        <row>
            <panel>
                <student-table
                    :items="students"
                    :sort-by="sort_by"
                    :columns="columns"
                    @sort-change="sortChange" />

                <div class="footer">
                    <pagination
                        :current-page="page"
                        :page-size="per_page"
                        :total="total"
                        layout="prev, pager, next, total"
                        @current-change="pageChange"/>
                    <div class="bulk-actions">
                        <label for="bulk-student-actions" class="visuallyhidden"> Select Bulk Action </label>
                        <app-select
                            id="bulk-student-actions"
                            v-model="bulkAction"
                            title="Select Bulk Action"
                            size="small"
                            placeholder="Bulk Student Actions">
                            <app-option
                                v-for="item in actions"
                                :key="item"
                                :label="item"
                                :value="item"/>
                        </app-select>
                        <app-button
                            :loading="loading"
                            :disabled="bulkDisable"
                            class="perform-action"
                            size="small"
                            @click="performBulkAction">Perform Action</app-button>
                    </div>
                </div>
            </panel>
        </row>
        <modal v-model="showAddStudent" size="small">
            <student-edit-view />
        </modal>
        <component
            :is="selectedBulkAction"
            v-model="showBulkAction"
            @selected-class="addBulkToSelection"
            @selected-event="addBulkToSelection"
            @selected-team="addBulkToSelection">
            <template slot="title">{{ bulkAction }}</template>
        </component>
    </dashboard>
</template>

<script>
import { isMobileScreenSize } from '@/utilities'
import table from '@/mixins/table'
import selectable from '@/mixins/selectable'
import Student from '@/store/models/Student'

import CoursePicker from '../Course/CoursePicker'
import EventPicker from '../Event/EventPicker'
import TeamPicker from '../Team/TeamPicker'
import StudentTable from './StudentTable'
import StudentEditView from './StudentEditView'

export default {
    name: 'page-students',
    components: {
        StudentTable,
        StudentEditView,
        CoursePicker,
        TeamPicker,
        EventPicker
    },
    mixins: [table, selectable],
    props: {
        state: {
            type: String,
            default: 'active'
        },
        missing: {
            type: String
        }
    },
    head: {
        title: {
            inner: 'Students'
        }
    },
    data() {
        return {
            studentIds: [],
            total: 0,
            showAddStudent: false,
            tableParamKeys: ['state', 'missing']
        }
    },

    computed: {
        students() { return Student.query().withAll().whereIdIn(this.studentIds).get() },
        columns() {
            let cols = [
                'bulk',
                'apa',
                'first_name',
                'last_name',
                'email',
                'last_seen'
            ]
            if (this.state == 'all') {
                cols.push('state')
            }
            return cols
        }
    },
    mounted() {
        this.getStudents(this.getParameters())
    },
    methods: {
        getStudents(params) {
            if (params.missing != null && params.missing == 'true') {
                params.missing = true
            }
            else {
                delete params['missing']
            }
            Student.$fetchAll(params)
                .then(({ data, raw }) => {
                    this.total = raw.total
                    this.studentIds = data.map((item) => item.id)
                })
        },
        navigateToStudentDetail(student) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        paramsChanged(params) {
            this.getStudents(params)
        },
        addNewStudent() {
            this.showAddStudent = true
        },
        stateChange(state) {
            let params = this.getParameters()
            params.state = state
            this.setParameters(params)
        },
        bulkRefresh() {
            this.getStudents(this.getParameters())
        },
        isMobileScreenSize
    }
}
</script>

<style lang="stylus">
.footer
    display: flex
    flex-direction: row
    justify-content: space-between
    align-content: center

.bulk-actions
    padding: 15px 0px 0px
    @media screen and (max-width: 640px)
        display: none

.perform-action
    margin-left: 15px
</style>
